import type { IJob } from '~/models';

/**
 * Whether the shift has a transaction history to link to.
 *
 * The same gate the legacy `transactionHistoryBtn` applied, and the condition
 * under which `Receipt`'s `totalAction` slot carries the affordance in the
 * redesign.
 *
 * Typed against a nullable job so the cancelled, completed and scheduled pages
 * can share it: two of them hold a job that is definitely loaded and one does
 * not. That widening is deliberate but it is a widening — a call site that used
 * to be told by the compiler that its job exists is no longer, so the check
 * reads the field optionally rather than trusting the caller.
 */
export const hasTransactionHistory = (job: Partial<IJob> | null | undefined): boolean =>
  Boolean(job?.transactions?.length);
